module.exports = __webpack_public_path__ + "img/ic-unionPay-white.6e8eb2d7.svg";